import React from 'react';
import timeDelta from '../../../../../../common/utility/timeDelta';

const ActivityCell = (props: { dataItem: { [x: string]: string | number | Date }; field: string | number }) => {
  return (
    <td>
      <div className="when-cell">{timeDelta(new Date(props.dataItem[props.field]))}</div>
    </td>
  );
};

export default ActivityCell;
